// require('./bootstrap');

import Vue from 'vue'
import VueMeta from 'vue-meta'
import {InertiaProgress} from '@inertiajs/progress'
import VueSweetalert2 from 'vue-sweetalert2';
import VueGoodTablePlugin from 'vue-good-table';
import vSelect from 'vue-select'
import {Vuelidate} from 'vuelidate';
import DatePicker from 'vue2-datepicker'
import JsonCSV from 'vue-json-csv';

import 'sweetalert2/dist/sweetalert2.min.css';
import 'vue-select/dist/vue-select.css';
import 'vue-good-table/dist/vue-good-table.css'
import 'vue2-datepicker/index.css';
import {createInertiaApp} from "@inertiajs/inertia-vue";
import Echo from "laravel-echo";
import JsonExcel from "vue-json-excel";
const _ = require('lodash');

window.Pusher = require("pusher-js");

Vue.mixin({methods: {route: window.route}})
Vue.use(VueMeta)
Vue.use(VueSweetalert2);
Vue.use(DatePicker);
Vue.use(Vuelidate);
Vue.use(VueGoodTablePlugin);
Vue.component('downloadCsv', JsonCSV);
Vue.component("downloadExcel", JsonExcel);
vSelect.props.components.default = () => ({
    Deselect: {
        render: createElement => createElement('span', '×'),
    },
    OpenIndicator: {
        render: createElement => createElement('span', { class: 'dropdown-caret' }),
    },
});
Vue.component('v-select', vSelect)
Vue.component('date-time-field', require('./components/DateTimeField.vue').default)
Vue.component('table-row-actions', require('./Shared/TableRowActions.vue').default);

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER ?? 'mt1',
//     wsHost: process.env.MIX_PUSHER_HOST ? process.env.MIX_PUSHER_HOST : `ws-${process.env.MIX_PUSHER_APP_CLUSTER}.pusher.com`,
//     wsPort: process.env.MIX_PUSHER_PORT ?? 80,
//     wssPort: process.env.MIX_PUSHER_PORT ?? 443,
//     forceTLS: (process.env.MIX_PUSHER_SCHEME ?? 'https') === 'https',
//     enabledTransports: ['ws', 'wss'],
// });

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_ABLY_PUBLIC_KEY,
    disableStats: true,
    encrypted: true,
    wsHost: 'realtime-pusher.ably.io',
    wsPort: 80,
    wssPort: 443,
    forceTLS: (process.env.MIX_PUSHER_SCHEME ?? 'https') === 'https',
    enabledTransports: ['ws', 'wss'],
});

window.axios = require('axios');

InertiaProgress.init()

createInertiaApp({
    resolve: name => require(`./Pages/${name}`),
    setup({el, app, props}) {
        new Vue({
            metaInfo: {
                titleTemplate: title => (title ? `${title} | Pizza Jungle` : 'Pizza Jungle'),
            },
            render: h => h(app, props),
        }).$mount(el);
    },
});

// window.Pusher = require("pusher-js");
// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER ?? 'mt1',
//     wsHost: process.env.MIX_PUSHER_HOST ? process.env.MIX_PUSHER_HOST : `ws-${process.env.MIX_PUSHER_APP_CLUSTER}.pusher.com`,
//     wsPort: process.env.MIX_PUSHER_PORT ?? 80,
//     wssPort: process.env.MIX_PUSHER_PORT ?? 443,
//     forceTLS: (process.env.MIX_PUSHER_SCHEME ?? 'https') === 'https',
//     enabledTransports: ['ws', 'wss'],
// });

window._ = _;


// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: '7841f4722910e16da9e1',
//     cluster: 'eu',
// });
